import RadioGroupFilter, {
  createRadioFilterTemplate,
} from '@/filters/RadioGroup';

export const options = [
  {
    key: true,
    label: 'Да',
  },
  {
    key: false,
    label: 'Нет',
  },
];

export const createTrueFalseFilter = createRadioFilterTemplate({
  initialValue: options[0].key,
  options,
});

export default RadioGroupFilter;
